import React, { Component }  from "react";
import {Container, Header} from 'semantic-ui-react'


export default class Footer extends Component{
  state = {}

  render() {
    return (
      <div>
        <Container style={{fontSize:'1vh', textAlign: 'center', paddingTop: '5vh'}}>
          <Header>Made with <span role="img" aria-label="heart">❤️</span> by Pictor Labs</Header>
        </Container>
      </div>
    )
  }
}  
